import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';

import type { AdmissionApplication } from '../../../types/admissions';
import type { GuardianLike } from './applicationFieldValues';
import { peopleService } from '../../../services/peopleService';

/**
 * The applicant family's Guardian records — where father / mother answers
 * live once the family is resolved. `null` while loading. Feeds
 * applicationFieldValue wherever answers are read back or corrected.
 */
export function useApplicantGuardians(app: AdmissionApplication | null, enabled = true): GuardianLike[] | null {
  const { enqueueSnackbar } = useSnackbar();
  const [guardians, setGuardians] = useState<GuardianLike[] | null>(null);
  const personId = app ? (typeof app.personId === 'object' ? app.personId?._id : app.personId) : undefined;
  // Reload after the application changes (e.g. a parent's details corrected).
  const version = app?.updatedAt;

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    setGuardians(null);
    if (!personId) { setGuardians([]); return; }
    peopleService.getPerson(personId)
      .then(d => { if (!cancelled) setGuardians(d.guardians); })
      .catch((err: any) => {
        if (cancelled) return;
        setGuardians([]);
        enqueueSnackbar(err?.message || 'Could not load guardian details', { variant: 'warning' });
      });
    return () => { cancelled = true; };
  }, [personId, version, enabled, enqueueSnackbar]);

  return guardians;
}
